import React, { useState } from 'react';

import { HtmlProps, HtmlPropsSchema } from '@usewaypoint/block-html';
import { Code } from 'lucide-react';

import BaseSidebarPanel, { SectionHeader } from './helpers/BaseSidebarPanel';
import TextInput from './helpers/inputs/TextInput';
import MultiStylePropertyPanel from './helpers/style-inputs/MultiStylePropertyPanel';
import { Separator } from '@/components/ui/separator';

type HtmlSidebarPanelProps = {
  data: HtmlProps;
  setData: (v: HtmlProps) => void;
};

export default function HtmlSidebarPanel({ data, setData }: HtmlSidebarPanelProps) {
  const [, setErrors] = useState<Zod.ZodError | null>(null);

  const updateData = (d: unknown) => {
    const res = HtmlPropsSchema.safeParse(d);
    if (res.success) {
      setData(res.data);
      setErrors(null);
    } else {
      setErrors(res.error);
    }
  };

  return (
    <BaseSidebarPanel title="HTML block">
      {/* CONTENT SECTION */}
      <div className="space-y-4">
        <SectionHeader icon={Code}>Content</SectionHeader>
        <div className="space-y-3">
          <TextInput
            label="HTML Content"
            rows={5}
            defaultValue={data.props?.contents ?? ''}
            onChange={(contents) => updateData({ ...data, props: { ...data.props, contents } })}
          />
        </div>
      </div>

      <Separator className="my-6" />

      {/* STYLING SECTION */}
      <div className="space-y-4">
        <SectionHeader>Styling</SectionHeader>
        <div className="space-y-3">
          <MultiStylePropertyPanel
            names={['color', 'backgroundColor', 'fontFamily', 'fontSize', 'textAlign', 'padding']}
            value={data.style}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>
    </BaseSidebarPanel>
  );
}
